import React, { useState, useCallback, useEffect } from "react"
import { IoIosClose } from "react-icons/io"
import { Modal } from "@/landing-page/components/modal"
import { PoliticaCookies } from "../politicacookies"

export function Cookies() {
  const [isModalOpenCookies, setIsModalOpenCookies] = useState<boolean>(true)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const toggleModalCookies = useCallback(() => {
    setIsModalOpenCookies((current) => !current)
  }, [])

  const toggleModal = useCallback(() => {
    setIsModalOpen((current) => !current)
  }, [])

  useEffect(() => {
    const cookies = document.cookie.split(';').some((item) => item.trim().startsWith('accept_cookies='))
    const handleScroll = () => {
      setIsModalOpenCookies(false)
    }
    
    setIsModalOpenCookies(cookies ? false : true)

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (!isModalOpenCookies) {
      document.cookie = "accept_cookies=true; path=/; max-age=" + (60 * 60 * 24 * 365) + "; secure; SameSite=Strict";
    }
  }, [isModalOpenCookies])

  if(isModalOpenCookies){
    return (
      <>
        <div className="pointer-events-none fixed bottom-0 z-40 w-full">
          <div className="relative flex justify-start">
            <div className="pointer-events-auto relative w-full bg-white p-5 lg:max-w-96 max-w-full">
              <button className="absolute right-0 top-0 block p-2 focus:focus-default" type="button" title="Fechar" onClick={toggleModalCookies}>
                <IoIosClose className="text-3xl" />
              </button>

              <h3 className=" text-green-dark text-lg font-semibold mb-4 shrink-0">Valorizamos a sua privacidade</h3>

              <p className="text-sm">Nós usamos cookies para melhorar a sua experiência e analisar nosso tráfego. Consulte nossa <button className="underline" onClick={toggleModal}>Política de Cookies</button>.</p>
            </div>
          </div>
        </div>

          {isModalOpen && (
            <Modal text={<PoliticaCookies/>} title="Política de Cookies" toggleModal={toggleModal} isOpen={isModalOpen}/>
          )}
      </>
    )
  }
  else {
    return null
  }
}